export default __webpack_public_path__ + "static/insta-hotels-11-3aab5989bca14020d5e3a02096b7f160.jpg";